// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","victoryStories":"victoryStories-2LGX9","stories":"stories-2STEd","story":"story-2n1kb","storyImage":"storyImage-1pNNx","storyTitle":"storyTitle-2Rz42"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app-page/victory-stories/_victoryStory.css
// module id = 1178
// module chunks = 1